import { render, staticRenderFns } from "./BankFields.vue?vue&type=template&id=f4e66f34&"
import script from "./BankFields.vue?vue&type=script&lang=js&"
export * from "./BankFields.vue?vue&type=script&lang=js&"
import style0 from "./BankFields.vue?vue&type=style&index=0&id=f4e66f34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports